import React from 'react'
import { CheckCircle, X } from '@phosphor-icons/react'

/**
 * @typedef {"success" | "warning" | "danger" | "default" | "info"} ToastType
 */

/**
 * @param {{ title: string, message: string, type?: ToastType }} props
 */


export const Toast = ({handleClose, title = '', message = '', type = "default"}) => {

	return (
    <React.Fragment>
      <div
        className={`relative flex gap-x-3 items-stretch justify-between text-white rounded-md shadow-lg
				${
          type === "success"
            ? "bg-success"
            : type === "warning"
            ? "bg-warning"
            : type === "danger"
            ? "bg-danger"
						: type === "info"
            ? "bg-info"
            : "bg-white"
        }
			`}
      >
        <div className={`bg-white/20 flex items-center p-3`}><CheckCircle size={20} weight='fill' /></div>
        <div className="flex-1 space-y-0.5 my-4">
					<p className='text-md font-medium'>{title}</p>
					<p className='text-xs font-normal'>{message}</p>
				</div>
        <button className='pr-2' onClick={handleClose} aria-label='close toast'>
					<X size={16} />
				</button>
      </div>
    </React.Fragment>
  );
}
